// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + chunkId + "." + {"787":"e14ae80a","897":"de1bcf56"}[chunkId] + ".chunk.js";
};